<template>
  <div
    class="zen-quick-search-desktop"
    :class="{
      'is-student-home': routeIsStudentHome,
    }"
  >
    <ZenSearchInput :show-backdrop="true" @navigate="handleNavigate" @close="emit('close')" />
  </div>
</template>

<script setup lang="ts">
import ZenSearchInput from './ZenSearchInput.vue';
import type { SearchResult } from '@/common/composables/useQuickSearch';

interface Props {
  routeIsStudentHome: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  routeIsStudentHome: false,
});

const emit = defineEmits<{
  navigate: [result: SearchResult];
  close: [];
}>();

function handleNavigate(result: SearchResult) {
  emit('navigate', result);
}
</script>

<style scoped>
.zen-quick-search-desktop {
  position: static;
  width: 400px;
  margin-left: 320px;
}

.zen-quick-search-desktop.is-student-home {
  margin-left: 365px;
}

@media (min-width: 1400px) {
  .zen-quick-search-desktop {
    left: 22%;
  }
}

@media (max-width: 1200px) {
  .zen-quick-search-desktop {
    left: 29%;
    width: 350px;
  }
}

@media (max-width: 1024px) {
  .zen-quick-search-desktop {
    left: 32%;
  }
}

@media (max-width: 768px) {
  .zen-quick-search-desktop {
    left: 28%;
  }
}

@media (max-width: 640px) {
  .zen-quick-search-desktop {
    left: 28%;
  }
}

@media (max-width: 480px) {
  .zen-quick-search-desktop {
    top: 4px;
    width: calc(100vw - 8px);
  }
}
</style>
